import React from 'react'

export const Star = () => {
  return (
    <div className='testimonials-recipe-comment-star'></div>
  )
}
